import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from '@reach/router';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import MuiContainer from '@material-ui/core/Container';
import { NavLink } from '../NavLink';
import { NavList } from '../NavList';

const ExpansionPanel = withStyles({
    root: {
        border: '0px',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0
        },
        '&:before': {
            display: 'none'
        },
        '&$expanded': {
            margin: 'auto'
        }
    },
    expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(0)
    }
}))(MuiExpansionPanelDetails);

const MenuSideBar = ({ listaMenu, permissoes, marignBottom }) => {
    const [expanded, setExpanded] = useState();

    const handleClick = (event, panel, link) => {
        event.preventDefault();
        setExpanded(panel !== expanded ? panel : false);
        if (
            event.target.nodeName.toUpperCase() !== 'SVG' ||
            event.target.nodeName.toUpperCase() !== 'PATH' ||
            event.target.nodeName.toUpperCase() !== 'BUTTON'
        ) {
            navigate(`${process.env.REACT_APP_BASE_URL}${link}`);
        }
    };

    const getElementoSemFilho = elemento => {
        const item = (
            <NavLink
                to={`${process.env.REACT_APP_BASE_URL}${elemento.path}`}
                key={`link ${elemento.texto}`}
                texto={elemento.texto}
            />
        );

        return item;
    };

    const getElementoHtml = (elemento, filhos) => {
        const item = (
            <div key={`div ${elemento.texto}`}>
                <ExpansionPanel
                    square
                    expanded={expanded === elemento.texto}
                    key={`ExpansionPanel ${elemento.texto}`}
                >
                    <NavLink
                        onClick={e =>
                            handleClick(e, elemento.texto, elemento.path)
                        }
                        to={`${process.env.REACT_APP_BASE_URL}${elemento.path}`}
                        key={`link ${elemento.texto}`}
                        texto={elemento.texto}
                        temFilhos
                    />
                    <ExpansionPanelDetails
                        key={`ExpansionPanelDetails ${elemento.texto}`}
                    >
                        <NavList elemento={elemento} listaFilhos={filhos} />
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </div>
        );

        return item;
    };

    const getMenu = (paramListaMenu, paramPermissoes) => {
        const menu = [];

        paramListaMenu.forEach(elemento => {
            if (!elemento.filhos || elemento.filhos.length === 0) {
                if (!elemento.permissoes || elemento.permissoes.length === 0) {
                    menu.push(getElementoSemFilho(elemento));
                }
                // permissoes.some(r => login.permissoes(r))
                if (
                    paramPermissoes.some(
                        r => elemento.permissoes.indexOf(r) !== -1
                    )
                ) {
                    menu.push(getElementoSemFilho(elemento));
                }
            } else {
                const filhos = [];
                elemento.filhos.forEach(elementoFilho => {
                    if (
                        paramPermissoes.some(
                            r => elementoFilho.permissoes.indexOf(r) !== -1
                        )
                    ) {
                        filhos.push(elementoFilho);
                    }
                });
                if (filhos.length > 0) {
                    menu.push(getElementoHtml(elemento, filhos));
                }
            }
        });
        return menu;
    };
    return (
        <MuiContainer
            style={{
                margin: `0px`,
                padding: '0px',
                flex: '1'
            }}
        >
            {getMenu(listaMenu, permissoes)}
        </MuiContainer>
    );
};

MenuSideBar.propTypes = {
    listaMenu: PropTypes.arrayOf(
        PropTypes.shape({
            texto: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired,
            permissoes: PropTypes.arrayOf(PropTypes.string),
            filhos: PropTypes.arrayOf(
                PropTypes.shape({
                    texto: PropTypes.string.isRequired,
                    path: PropTypes.string.isRequired,
                    permissoes: PropTypes.string.isRequired
                })
            )
        })
    ).isRequired,
    permissoes: PropTypes.arrayOf(PropTypes.string).isRequired,
    marignBottom: PropTypes.number.isRequired
};

export { MenuSideBar };
export default MenuSideBar;
